import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';

import {
    withStyles, Typography, List, ListItem, ListItemText, ListItemAvatar, ListItemSecondaryAction, IconButton, Avatar, ListItemIcon, Divider,
} from '@material-ui/core';

import { AddIcon, RemoveIcon, PersonIcon } from '../../../common/icons';

import * as PatientStore from '../../../app/store/PatientStore';
import * as TeacherStore from '../../../app/store/TeacherStore';
import { appRoles } from '../../../youwell-common/constants';

const styles = theme => ({
    root: {
    },
    actions: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
    },
    addIcon: {
        marginRight: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(1),
    },
});

class EditTeachers extends React.Component {
    componentDidMount() {
        if (!this.props.teacherList) {
            this.props.fetchTeacherList({ requestParams: { minimumRole: appRoles.therapist } });
        }
    }

    add = therapistId => () => {
        const data = {
            patientId: this.props.studentData.id,
            therapistId,
        };
        this.props.insertPatientTherapist(data);
    }

    remove = id => () => {
        const data = {
            patientId: this.props.studentData.id,
            therapistId: id,
        };
        this.props.deletePatientTherapist(data);
    }

    render() {
        const {
            classes, translate, studentData, teacherList,
        } = this.props;

        if (!studentData) {
            return null;
        }

        const studentTeachers = (studentData.therapists || {}).reduce((prev, curr) => (
            { ...prev, [curr.therapistId]: true }
        ), {});

        return (
            <div className={classes.root}>
                <Typography variant="subtitle1">
                    {translate('student.assignedTeachers')}
                </Typography>
                <List>
                    {studentData.therapists && studentData.therapists.map(item => (
                        <ListItem key={item.therapistId}>
                            <ListItemAvatar>
                                <Avatar>
                                    <PersonIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={item.therapistName} />
                            <ListItemSecondaryAction>
                                <IconButton aria-label="Delete" onClick={this.remove(item.therapistId)}>
                                    <RemoveIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>

                <Divider className={classes.divider} />

                <div className={classes.actions}>
                    <Typography variant="subtitle1">
                        {translate('student.addTeacher')}
                    </Typography>

                    <List>
                        {teacherList && teacherList.filter(d => !studentTeachers[d.id]).map(item => (
                            <ListItem button key={`${item.id}_${item.role}`} onClick={this.add(item.id)}>
                                <ListItemIcon>
                                    <AddIcon />
                                </ListItemIcon>
                                <ListItemText primary={item.name} secondary={item.email} />
                            </ListItem>
                        ))}
                    </List>

                </div>

            </div>
        );
    }
}

EditTeachers.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            studentId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    studentData: PropTypes.object.isRequired,
    insertPatientTherapist: PropTypes.func.isRequired,
    deletePatientTherapist: PropTypes.func.isRequired,
    fetchTeacherList: PropTypes.func.isRequired,
    teacherList: PropTypes.array,
};

EditTeachers.defaultProps = {
    teacherList: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    studentData: state.patient.details && state.patient.details[ownProps.match.params.studentId],
    teacherList: state.teacher.list,
    profileData: state.auth.profileData,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PatientStore.actionCreators, dispatch),
    fetchTeacherList: bindActionCreators(TeacherStore.actionCreators, dispatch).getList,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditTeachers)));
